// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7c4a947f","703":"873f7358"}[chunkId] + ".chunk.js";
};